import { ReactNode } from 'react';
import { MenuItem, ListItemIcon, ListItemText, Link } from '@mui/material';

interface IProps {
  icon: ReactNode;
  text?: string;
  divider?: boolean;
  link: string;
}

export const PopUpLink = ({ icon, text, divider, link }: IProps) => {
  return (
    <MenuItem id="pop-up-link-component__components-menu-burger__menuitem__l13" sx={{ padding: 2 }} divider={divider}>
      <ListItemIcon id="pop-up-link-component__components-menu-burger__listitemicon__l14">{icon}</ListItemIcon>
      {text &&
      <Link id="pop-up-link-component__components-menu-burger__link__l16" href={link} color="currentcolor" underline="none">
          <ListItemText id="pop-up-link-component__components-menu-burger__listitemtext__l17">{text}</ListItemText>
        </Link>
      }
    </MenuItem>);

};